import { Input, Modal } from 'antd';
import CopyToClipboardIcon from 'Components/common/assets/svgIcons/CopyToClipboardIcon';
import React from 'react';
import CrossCircle from 'Components/common/assets/svgIcons/CrossCircle';

type Props = {
  isShowPopup: boolean,
  onClickCancel: () => void,
  url: string,
  copyToClipboard: () => void,
};

const CopyToClipboardPopup = function CopyToClipboardPopup(props: Props) {
  const {
    isShowPopup, onClickCancel, url, copyToClipboard,
  } = props;
  return (
    <Modal
      centered
      width={689}
      closeIcon={<CrossCircle />}
      getContainer=""
      wrapClassName="modal-copy-to-clipboard"
      open={isShowPopup}
      onCancel={onClickCancel}
      closable
    >
      <span className="heading-copy-popup">Share profile link</span>
      <div className="input-button-div">
        <div className="clipboard-icon">
          <CopyToClipboardIcon />
        </div>
        <Input
          className="clipboard-input"
          type="text"
          value={url}
        />
        <span
          tabIndex={0}
          role="button"
          className="copy-link-button"
          onClick={() => copyToClipboard()}
          onKeyPress={() => copyToClipboard()}
        >
          Copy Link
        </span>
      </div>
    </Modal>
  );
};
export default CopyToClipboardPopup;
